import { Route, Routes } from "react-router";
import FormManager from "./pages/FormManager";

function ErrorPage() {
  const { code, status, message } = location.state || {};
  document.title = `Erreur : ${status}  ${code} `;

  return (
    <div className="flex items-center justify-center min-h-screen bg-custom-gradient">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md flex flex-col gap-4">
        <h1 className="text-6xl font-bold text-red-600 mb-4">Erreur 404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Oups ! Une erreur est survenue.
        </h2>
        {code && (
          <p className="text-lg text-gray-600 mb-4">Code d'erreur : {code}</p>
        )}
        {message || <p className="text-base text-gray-600 mb-4">{}</p>}
        <div className="mx-auto pt-8">
          <a href={"/"} className="w-60">
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
}

const FormComponent = () => <FormManager />;

// TODO loginPage , Profiles .

function App() {
  return (
    <Routes>
      <Route path={"/"} element={<FormComponent />}>
        <Route path=":token" element={<FormComponent />} />
      </Route>

      {/*Accès Error*/}
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
